import type { FC } from 'react';
import type { ButtonProps } from 'react-native-paper';
import { Button } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = Omit<ButtonProps, 'mode' | 'theme'> & {
  /**
   * Outline color override. Defaults to the theme's primary color. Use
   * `theme.colors.outlineVariant` for the neutral/secondary look (e.g.
   * LabelButton).
   */
  outlineColor?: string;
};

/**
 * A react-native-paper Button with the app-wide outlined-button styling:
 * always `mode="outlined"`, with the outline drawn in the primary color
 * instead of the theme's default (neutral) outline color. Pass
 * `outlineColor` for a non-primary outline.
 */
export const OutlinedButton: FC<Props> = ({ outlineColor, ...buttonProps }) => {
  const theme = useAppTheme();

  return (
    <Button
      mode="outlined"
      theme={{ colors: { outline: outlineColor ?? theme.colors.primary } }}
      {...buttonProps}
    />
  );
};
